<template>
  <section class="section community-section">
    <b-row>
      <b-col md="6">
        <h2 class="display-4 mb-5">Join us on Discord</h2>
        <ul class="list-unstyled">
          <li class="d-flex mb-4">
            <i class="pe-3x pe-7s-plugin accent mr-5"></i>
            <span class="align-self-center features-list-single">
              Request new features
            </span>
          </li>
          <li class="d-flex mb-4">
            <i class="pe-3x pe-7s-bandaid accent mr-5"></i>
            <span class="align-self-center features-list-single">
              Report bugs
            </span>
          </li>
          <li class="d-flex">
            <i class="pe-3x pe-7s-like accent mr-5"></i>
            <span class="align-self-center features-list-single">
              Talk with the community
            </span>
          </li>
        </ul>
      </b-col>

      <b-col offset-lg="1" lg="5" md="6">
        <div
          class="card mb-2 float-lg-right shadow"
          style="max-width: 20rem"
          data-aos="flip-right"
        >
          <img
            class="card-img-top"
            src="@/assets/img/stylists.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <h4 class="card-title">Meet the community</h4>
            <p class="card-text card-text-discord">
              Our community is the heart and soul of everything we do.
              <strong>Join us on Discord</strong> and have your say on what we
              build next.
            </p>
            <b-button
              size="lg"
              variant="outline-unstitched"
              class="connect-btn"
              target="_blank"
              rel="noopener noreferrer"
              href="https://discord.gg/dzcC8mm"
            >
              Connect
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import router from "@/router";
import { mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    clickOpenSignUpModal() {
      if (this.currentUser) {
        router.push({ name: "DiscoverCapsules" });
      } else {
        bus.$emit("openSignUpModal");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.community-section {
  margin-bottom: 160px;

  .display-4 {
    font-weight: 300;
    font-size: 3rem;
  }

  .accent {
    color: $primary-accent;
  }

  .features-list-single {
    font-size: 18px;
  }

  .connect-btn {
    font-weight: 400;
  }

  .card-text-discord {
    padding-top: 10px;
    padding-bottom: 15px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/CommunitySection.vue